import HSBColor from '../classes/hsb-color';
import constants from '../constants';

const { COMMON } = constants;
const rgb2hsb = ({ red, green, blue, alpha }) => {
  let h = 0;
  let s = 0;
  const b = Math.max(red, green, blue);
  const min = Math.min(red, green, blue);

  if (b - min > COMMON.ACCURACY) {
    s = (b - min) / b;
    switch (b) {
      case red:
        h = (60 * (green - blue)) / (b - min);
        break;
      case green:
        h = (60 * (blue - red)) / (b - min) + 120;
        break;
      case blue:
      default:
        h = (60 * (red - green)) / (b - min) + 240;
    }
  }
  h = Math.round(h + 360) % 360;
  return new HSBColor(h, s, b, alpha);
};

export default rgb2hsb;
